import {
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import {colors} from '../../../options/colors';
import {Close} from '@mui/icons-material';

export const StyledModal = styled(Dialog)(({ theme, width }) => ({
  background: 'rgba(0, 0, 0, 0.7)',
  '.MuiPaper-root': {
    margin: '30px 0',
    padding: 0,
    background: colors.black,
    width: width ? width : '100%',
    maxWidth: '800px !important',
    borderRadius: 5,
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
  },
}));

export const ModalHeader = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '30px 30px 0',
}));

export const ModalContent = styled(DialogContent)(() => ({
  padding: '0 30px 30px',
}));

export const ModalActions = styled(DialogActions)(() => ({
  padding: '17px 30px',
  borderTop: `1px solid ${colors.secondaryGrey}`
}));

export const CloseButton = styled(IconButton)(() => ({
  padding: 2,
  transition: 'all 0.3s ease',
  alignSelf: 'flex-start',
}));

export const CloseIcon = styled(Close)(() => ({
  color: colors.white,
  fontSize: 22,
}));
